import { OmapiIdConstants } from '../shared/omapi-id-constants';
import { ImageUtils } from '../shared/utils/image/image-utils';
var Order = /** @class */ (function () {
    function Order(packOmapiId, packPrice, subPackOmapiId, subPackPrice, type) {
        if (type === void 0) { type = Order.ORDER; }
        this.packOmapiId = packOmapiId;
        this.subPackOmapiId = subPackOmapiId;
        this.packPrice = packPrice;
        this.subPackPrice = subPackPrice;
        this.type = type;
    }
    Order.prototype.orderName = function () {
        if (this.subPackOmapiId) {
            return OmapiIdConstants.PRODUCT_NAME_MAP.get(this.packOmapiId) + ', ' + OmapiIdConstants.PRODUCT_NAME_MAP.get(this.subPackOmapiId);
        }
        return OmapiIdConstants.PRODUCT_NAME_MAP.get(this.packOmapiId);
    };
    Order.prototype.getLogoUrl = function () {
        if (this.subPackOmapiId) {
            return ImageUtils.getLogoUrlForOmapiId(this.packOmapiId + '-' + this.subPackOmapiId);
        }
        return ImageUtils.getLogoUrlForOmapiId(this.packOmapiId);
    };
    Order.ORDER = 'order';
    Order.DAYPASS = 'daypass';
    Order.TRIALS = 'trials';
    return Order;
}());
export { Order };
